export default "__VITE_ASSET__DFh3klpV__"